module.exports = __webpack_public_path__ + "static/media/icon.093e1926.png";